import React from 'react'
import PhoneInput from 'react-phone-input-2'
import "react-phone-input-2/lib/style.css";


const PhoneNumberField = React.memo(({
    value,
    onChange,
    error,
})=>{

    const handleChange = (fullValue, countryData) => {
        const countryCode = `+${countryData.dialCode}`;
        // console.log("fromComponent",fullValue);
        const phoneNumber = fullValue.replace(/\D/g, ""); // Remove non-digit characters

        // Pass the updated value while preserving previous valid state
        onChange({
            countryCode,
            phoneNumber,
        });
    };

    return(
        <div style={{width: "100%"}}>
            <PhoneInput
                country={value.countryCode ? value.countryCode : "us" }
                value={value.phoneNumber}//6854525689
                onChange={handleChange}
                enableSearch={true}
                inputStyle={{
                    width: "100%",
                    height: "40px",
                    borderRadius: "5px",
                    border: error ? "1px solid red" : "1px solid #ced4da",
                }}
                containerStyle={{
                    borderRadius: "10px",
                }}
            />
            <div
                style={{
                    margin: "0 0 0 0",
                    textAlign: "left",
                    // position: "absolute",
                    bottom: "1px",
                    color: "red",
                    width: "100%",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    cursor: "pointer",
                }}
            >
                {
                    error ? <span style={{fontSize: ".8rem"}}>{error}</span> : ""
                }
            </div>
        </div>
    )
});

export {PhoneNumberField}